import React from 'react';
import { FontWeights, Toggle, } from 'office-ui-fabric-react/lib';
import { MyContext } from '../../../context';
import gql from 'graphql-tag';
import { toast } from 'react-toastify';
import Utils from '../../common/Utils';
import UserPicker from './../../ReportView/ReportConfiguration/UserPicker';
import DateTimePicker from 'react-datetime-picker';
import { Query } from "@apollo/react-components";
import { queryGetConfigData, queryGetAWSRegions, mutationMarkDeleteExportRule, getProcessingRegions, checkExportConnectionString, mutationCreatePublicKey } from "../../../queries/querySettings";
import {
    DefaultButton,
    PrimaryButton,
    Stack,
    TextField,
    Dropdown,
    ComboBox, Checkbox, Spinner, Label, ChoiceGroup, Text
} from "office-ui-fabric-react";
import '../../RuleSetter/Setter.scss';
import { iniGraphqlUrl } from "../../../ini/ini";


const checkboxStyles = () => {
    return {
        root: {
            marginTop: '10px'
        }
    };
};
const textFieldIndentStyles = () => {
    return {
        root: {
            marginTop: '10px',
            marginLeft: '20px',
            marginBottom: '10px'
        }
    };
};
class ExportConfig extends React.Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();

        let exportUser = [];
        let exportUserSource = (this.props.data == null || this.props.data.userIds === "undefined" || this.props.data.userIds == null || this.props.data.userIds == "") ? "" : this.props.data.userIds;
        for (let x = 0; x < exportUserSource.length; x++) {
            exportUser.push({
                userId: exportUserSource[x],
                key: exportUserSource[x]
            }
            );
        }

        //I added this part because for new jobs or existing recent jobs are fine with new Date() and new date(jobTime)
        //but we have old jobs that have as value '0001-01-01T00:00:00' and it's not working because it's not recognized as a valid DateTime because it reads as 0000-12-31T22:15:36.000Z
        //so in case of an old wrong value I will change it in 0001-01-01T00:00:00Z because the Z adds an extra 1h:44min and is able to read the date correct
        let jobTime = new Date();
        let callTimeStart = new Date();
        if (this.props.data != null && this.props.data.jobType != null) {
            if (this.props.data.jobType.jobStartTime === '0001-01-01T00:00:00') {
                jobTime = new Date('0001-01-01T00:00:00Z');
            } else if (this.props.data.jobType.jobStartTime === '') {
                jobTime = new Date();
            } else {
                jobTime = new Date(this.props.data.jobType.jobStartTime)
            }
        }
        //same for this case
        if (this.props.data != null) {
            if (this.props.data.callStartTime === '0001-01-01T00:00:00') {
                callTimeStart = new Date('0001-01-01T00:00:00Z');
            } else if (this.props.data.callStartTime === '') {
                callTimeStart = new Date();
            } else {
                callTimeStart = new Date(this.props.data.callStartTime)
            }
        }

        let typeListSource = this.getTypeListSource();

        this.state = {
            name: this.props.data != null ? this.props.data.name : "Export",
            id: this.props.isNew ? Utils.guidGenerator() : this.props.data.id,
            jobStartTime: jobTime,
            intervalType: (this.props.data != null && this.props.data.jobType != null) ? this.props.data.jobType.intervalType : "OneTime",
            intervalMonth: (this.props.data != null && this.props.data.jobType != null) ? this.props.data.jobType.intervalMonth : 0,
            intervalDay: (this.props.data != null && this.props.data.jobType != null) ? this.props.data.jobType.intervalDay : 0,
            intervalHour: (this.props.data != null && this.props.data.jobType != null) ? this.props.data.jobType.intervalHour : 0,
            intervalMinute: (this.props.data != null && this.props.data.jobType != null) ? this.props.data.jobType.intervalMinute : 0,
            exportUser: exportUser,
            exportType: (this.props.data != null && this.props.data.exportType != null) ? this.props.data.exportType : "Blobstorage",
            audioCodec: (this.props.data != null && this.props.data.audioCodec != null) ? this.props.data.audioCodec : "Wav",
            sourceTtl: this.props.isNew ? -1 : this.props.data.sourceTtl,
            sourceTtlEnabled: this.props.isNew ? false : this.props.data.sourceTtl != -1,
            storageConnectionString: this.props.isNew ? "" : this.props.data.storageConnectionString,
            storageContainerName: this.props.isNew ? "ascexport" : this.props.data.storageContainerName,
            storageRootDirectory: this.props.isNew ? "" : this.props.data.storageRootDirectory,
            mediaType: this.props.isNew ? 0 : this.props.data.conversationType,
            enabled: this.props.isNew ? true : this.props.data.enabled,
            processingRegion: this.props.isNew ? "North Europe" : this.props.data.processingRegion,
            callStartTime: callTimeStart,
            callEndTime: ((this.props.data != null && this.props.data.callEndTime !== '')) ? new Date(this.props.data.callEndTime) : '9999-12-31T23:59:59',
            defaultRegion: (this.props.data != null && this.props.data.defaultRegion != null) ? this.props.data.defaultRegion : "",
            PGPEncryption: (this.props.data != null && this.props.data.pgpEncryption != null) ? this.props.data.pgpEncryption : false,
            pgpEncryptionKeyUpload: "",
            policyResultTypes: (this.props.data && this.props.data.policyResultType) ? this.props.data.policyResultType : 0,
            selectedFile: (this.props.data != null && this.props.data.pgpEncryption != null) ? this.props.data.pgpEncryption : false,
            sftpPrivateKeyUpload: "",
            hasSftpKey: (this.props.data !== null && this.props.data.hasSftpKey !== null) ? this.props.data.hasSftpKey : false,
            auditEventTypes: (this.props.data !== null && this.props.data.auditEventTypes !== null) ? this.props.data.auditEventTypes : "",
            jobDeletionActive: false,
            mergeAudioToVideo: (this.props.data != null && this.props.data.mergeAudioToVideo != null) ? this.props.data.mergeAudioToVideo : false,
            metadataInTranscript: (this.props.data != null && this.props.data.metadataInTranscript != null) ? this.props.data.metadataInTranscript : false,
            transferId: this.props.isNew ? "" : this.props.data.transferId,
            downloadNeoTransferTextBtn: "downloadNeoTransferFile",
            isValidUUID: true,
            validateStorageConnectionString: "",
            storageConnectionStringChanged: false,
            encryptionKeyVaultUrl: this.props.isNew ? "" : this.props.data.encryptionKeyVaultUrl,
            customFieldOptions: this.props.customFieldsData ? this.props.customFieldsData : [],
            customFieldKey: this.props.data != null && this.props.data.customFieldKey != null ? this.props.data.customFieldKey : "",
            customFieldValue: this.props.data != null && this.props.data.customFieldValue != null ? this.props.data.customFieldValue : "",
            isCustomFieldEqual: this.props.data != null && this.props.data.isCustomFieldEqual != null ? this.props.data.isCustomFieldEqual : false,
            conversationClientId: this.props.data?.conversationClientId ?? "",
            conversationClientSecret: this.props.data?.conversationClientSecret ?? "",
            voiceClientId: this.props.data?.voiceClientId ?? "",
            voiceClientSecret: this.props.data?.voiceClientSecret ?? "",
            filterType: typeListSource,
            durationFrom: this.props.data?.durationFrom != null ? this.props.data.durationFrom : -1,
            durationTo: this.props.data?.durationTo != null ? this.props.data.durationTo : -1,
            participantCountFrom: this.props.data?.participantCountFrom != null ? this.props.data.participantCountFrom : -1,
            participantCountTo: this.props.data?.participantCountTo != null ? this.props.data.participantCountTo : -1,
            subTypeMapping: this.props.data?.subTypeMapping
                ? typeof this.props.data.subTypeMapping === "string"
                    ? JSON.parse(this.props.data.subTypeMapping)
                    : this.props.data.subTypeMapping
                : {},
            publicKeyText: "createPublicKey",
            sftpPublicKeyFileContent: null,
            publicKeyLoading: false,
            publicKeyPassword: "",
            sftpPrivateKeyFileContent: null,
            sftpPrivateKeyKeyVaultUrl: this.props.data?.sftpPrivateKeyKeyVaultUrl ?? "",
            sftpPrivateKeyKeyVaultSecretName: this.props.data?.sftpPrivateKeyKeyVaultSecretName ?? "",
            keyOption: "generate",
            callDateError: "",
            callEndIsClockOpen: false,
            exportMetadata: (this.props.data != null && this.props.data.exportMetadata != null) ? this.props.data.exportMetadata : true
        };

    }

    policyResultTypesOptions = [
        { key: 1, text: "AIAssistantResults" },
        { key: 2, text: "AICategorizationTaggedCategories" },
        { key: 4, text: "PolicyRuleResults" },
        { key: 8, text: "ScorecardResults" },
        { key: 16, text: "CategoriesAndKeywords" },
        { key: 32, text: "ContentUnderstanding" }
    ];

    exportTypeOptions = [
        { key: "Blobstorage", text: "BlobStorage" },
        { key: "Neo", text: "EVOIPneo" },
        { key: "Hubstor", text: "Hubstor" },
        { key: "Bloomberg", text: "Bloomberg Vault" },
        { key: "SFTP", text: "SFTP/FTP" },
        { key: "AWS", text: "AWS S3" },
        { key: "eKontakt", text: "eKontakt" },
        { key: "AuditLogSFTPCustom", text: "AuditLogSFTPCustom" },
        { key: "azureDatalake", text: "Azure Datalake" },
        { key: "AuditEvent", text: "Audit Event" },
        { key: "NeoTransfer", text: "Neo Transfer" },
        { key: "SurveilX", text: "Surveil-X" },
        { key: "GlobalRelay", text: "Global Relay" }
    ];

    exportTypePushOptions = [
        { key: "Blobstorage", text: "BlobStorage" },
        { key: "Neo", text: "EVOIPneo" },
        { key: "Hubstor", text: "Hubstor" },
        { key: "SFTP", text: "SFTP/FTP" },
        { key: "AWS", text: "AWS S3" },
        { key: "azureDatalake", text: "Azure Datalake" },
        { key: "NeoTransfer", text: "Neo Transfer" }
    ];

    auditLogTypesOptions =
        [
            {
                key: "RECORDING_CONVERSATION",
                text: "Recording conversation",
            },
            {
                key: "RECORDING_NOTRECORDED",
                text: "Recording not recorded",
            },
            {
                key: "REPLAY_CONVERSATION",
                text: "Replay conversation",
            },
            {
                key: "REPLAY_REQUEST",
                text: "Replay request",
            },
            {
                key: "REPLAY_APPROVED",
                text: "Replay approved",
            },
            {
                key: "DELETE_CONVERSATION",
                text: "Delete conversation",
            },
            {
                key: "DELETE_REQUEST",
                text: "Delete request",
            },
            {
                key: "DELETE_APPROVED",
                text: "Delete approved",
            },
            {
                key: "ANALYTICS_MANUAL",
                text: "Analytics manual",
            },
            {
                key: "RULE_NEW",
                text: "Rule New",
            },
            {
                key: "RULE_ASSIGN",
                text: "Rule assign",
            },
            {
                key: "RULE_DELETE",
                text: "Rule delete",
            },
            {
                key: "RULE_CHANGE",
                text: "Rule change",
            },
            {
                key: "SETTING_CHANGE",
                text: "Setting change",
            },
            {
                key: "USER_ADD",
                text: "User add",
            },
            {
                key: "USER_DELETE",
                text: "User Delete",
            },
            {
                key: "TENANT_ADD",
                text: "Tenant add",
            },
            {
                key: "TENANT_CHANGE",
                text: "Tenant change",
            },
            {
                key: "PARTNER_ADD",
                text: "Partner add",
            },
            {
                key: "PARTNER_CHANGE",
                text: "Partner change",
            },
            {
                key: "RECORDING_EXPORT",
                text: "Recording export",
            },
            {
                key: "RECORDING_UPLOAD",
                text: "Recording upload",
            },
            {
                key: "USER_LOGIN",
                text: "User login",
            },
            {
                key: "USER_CHANGE",
                text: "User change",
            },
            {
                key: "GROUP_ADD",
                text: "Group add",
            },
            {
                key: "GROUP_DELETE",
                text: "Group delete",
            },
            {
                key: "GROUP_CHANGE",
                text: "Group change",
            },
            {
                key: "RECORDING_IMPORT",
                text: "Recording import",
            },
            {
                key: "DELETE_MANUAL_CONVERSATION",
                text: "Delete manual conversation",
            },
            {
                key: "RECORDING_SWITCH",
                text: "Recording switch",
            },
            {
                key: "RECORDING_DISABLE_NEXT",
                text: "Recording disable next",
            },
            {
                key: "RECORDING_DISABLE_CANCEL",
                text: "Recording disable cancel",
            },
            {
                key: "RECORDING_DISABLE_STOP",
                text: "Recording disable stop",
            },
            {
                key: "RECORDING_DISABLE_CURRENT",
                text: "Recording disable current",
            },
            {
                key: "RESTORE_ARCHIVE_REQUEST",
                text: "Restore archive request",
            },
            {
                key: "RESTORE_ARCHIVE_APPROVED",
                text: "Restore archive approved",
            },
            {
                key: "RESTORE_ARCHIVE",
                text: "Restore archive",
            },
            {
                key: "RECORDING_ARCHIVE",
                text: "Recording archvive",
            },
            {
                key: "POLICYRULE_DELETE",
                text: "Policy rule delete",
            },
            {
                key: "TTL_CHANGE",
                text: "TTL change",
            },
            {
                key: "AUDIT_EXPORT",
                text: "Audit export",
            },
            {
                key: "CONVERSATION_COMPRESSED_TO_MP3",
                text: "Conversation compressed to MP3",
            }];
    updateSelectedOptionKeys = (selectedKeys, option): string[] => {
        selectedKeys = [...selectedKeys]; // modify a copy
        const index = selectedKeys.indexOf(option.key);
        if (option.selected && index < 0) {
            selectedKeys.push(option.key);
        } else {
            selectedKeys.splice(index, 1);
        }
        return selectedKeys;
    };

    findKeys = (k, options) => {
        let out;
        for (let x = 0; x < options.length; x++) {
            if (k === options[x].key) {
                out = options[x];
                break;
            }
        }
        return out;
    }
    onChangeMulti = (event, option, index, value) => {
        console.log('_onChangeMulti() is called: option = ' + JSON.stringify(option));
        const currentSelectedKeys = this.state.auditEventTypes || [];
        if (option) {
            // User selected/de-selected an existing option
            const tmp = this.updateSelectedOptionKeys(currentSelectedKeys, option);
            let xx = [];
            for (let i = 0; i < tmp.length; i++) {
                xx.push(this.findKeys(tmp[i], this.auditLogTypesOptions))
            }
            this.setState({
                auditEventTypes: tmp,
                updated: true
            });
        }
    };
    changeTab(newActiveTabIndex) {
        this.setState({
            activeTabIndex: newActiveTabIndex
        });
    }
    onFileChangePGP = event => {

        let activeFile = event.target.files[0];

        if (activeFile) {
            this.setState({ selectedFile: true });

        }

        if (event.target.files[0]) {
            this.loadFile(event.target.files[0]);

        }

    };

    loadFile = async (file) => {
        let text = await file.text();
        this.setState({ pgpEncryptionKeyUpload: text });
    }
    loadFileSftp = async (file) => {
        let text = await file.text();
        this.setState({ sftpPrivateKeyUpload: text });
    }

    onFileChangeSftp = event => {

        let activeFile = event.target.files[0];

        if (activeFile) {
            this.setState({ hasSftpKey: true });

        }

        if (event.target.files[0]) {

            this.loadFileSftp(event.target.files[0]);
        }

    };
    downloadNeoTransferFile = async () => {
        this.setState({ downloadNeoTransferTextBtn: "downloading" });

        let data = await this.props.apol
            .mutate({
                mutation: gql`
                 mutation ent ($input: AuthInput, $transferId:String, $graphAPIUri:String) {
                    downloadNeoTransferFile (input: $input, transferId:$transferId, graphAPIUri:$graphAPIUri) 
                }
            `,
                variables: {
                    input: this.props.authorization,
                    transferId: this.state.transferId,
                    graphAPIUri: iniGraphqlUrl
                },
            });

        if (data.data.downloadNeoTransferFile !== null) {

            let content = data.data.downloadNeoTransferFile;
            if (!content) {
                toast.error('Download not successful', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                this.setState({ downloadNeoTransferTextBtn: "downloadNeoTransferFile" });

            } else {

                let blob = new Blob([content], { type: "text/plain" });
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = "transfer_[" + this.props.data.tenantId + "]_[" + this.state.transferId + "].bin";
                a.click();
                this.setState({ downloadNeoTransferTextBtn: "downloadNeoTransferFile" });
            }


        }
    }

    handlePolicyResultTypeChange = (key, checked) => {
        let value = this.state.policyResultTypes;
        if (checked) {
            value = value | key;
        } else {
            value = value & ~key;
        }
        this.setState({ policyResultTypes: value, updated: true });
    };

    isPolicyResultTypeChecked = (key) => {
        return (this.state.policyResultTypes & key) === key;
    };

    validateUUID = (value) => {
        if (value === "") {
            return true;
        }
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return uuidRegex.test(value);
    }

    getSelectOptionsType = (context) => {
        let allOptions = [
            { key: 'Inbound', text: context.getTranslation("filterPanel", "inbound") },
            { key: 'Outbound', text: context.getTranslation("filterPanel", "outbound") },
            { key: 'Meeting', text: context.getTranslation("filterPanel", "meetings") },
            { key: 'Internal', text: context.getTranslation("filterPanel", "internal") },
            { key: 'External', text: context.getTranslation("filterPanel", "external") },
            { key: 'Chat', text: context.getTranslation("configuration", "chat") },
            { key: 'Upload', text: context.getTranslation("filterPanel", "upload") },
            { key: 'SMS', text: context.getTranslation("filterPanel", "sms") },
            { key: 'Mail', text: context.getTranslation("filterPanel", "mail") }
        ]

        return allOptions
    }

    validateFromTo = () => {
        if (this.state.durationFrom !== -1 && this.state.durationTo !== -1 && this.state.durationFrom > this.state.durationTo) {
            return false;
        }
        return true;
    }

    validateParticipantsFromTo = () => {
        if (this.state.participantCountFrom !== -1 && this.state.participantCountTo !== -1 && this.state.participantCountFrom > this.state.participantCountTo) {
            return false;
        }
        return true;
    }

    getTypeListSource = () => {
        let typeListSource = [];
        if (this.props.data != null && this.props.data.filterType != null && this.props.data.filterType != "") {
            typeListSource = this.props.data.filterType.split(',');
        }
        return typeListSource;
    }

    handleTransferIdChange = (event, newValue) => {
        const isValidUUID = this.validateUUID(newValue);
        this.setState({ transferId: newValue, isValidUUID });
    }

    checkStorageConnectionString = async () => {
        this.setState({ validateStorageConnectionString: "pending" });

        const storageConnectionStringEl = document.getElementById("storageConnectionString");
        const storageContainerNameEl = document.getElementById("storageContainerName");
        const errorEl = document.getElementById("storageConnectionStringError");
        const checkBtnEl = document.querySelector("#checkBtn");

        // Reset styles and error
        [storageConnectionStringEl, storageContainerNameEl, checkBtnEl].forEach(el => el && (el.style.border = ""));
        if (errorEl) errorEl.innerHTML = "";

        let sftpPrivateUploadValue = "";
        let sftpPrivateKeyFileContentValue = "";
        if (["SFTP", "AuditLogSFTPCustom", "eKontakt", "AuditEvent", "SurveilX"].includes(this.state.exportType)) {
            sftpPrivateUploadValue = this.state.sftpPrivateKeyUpload;
            sftpPrivateKeyFileContentValue = this.state.sftpPrivateKeyFileContent
        }

        const result = await this.props.apol.mutate({
            mutation: checkExportConnectionString,
            variables: {
                input: this.props.authorization,
                exportRuleType: this.state.exportType,
                storageConnectionString: this.state.storageConnectionString,
                storageContainerName: this.state.storageContainerName,
                awsExportRegion: this.state.defaultRegion,
                neoTransferId: this.state.transferId,
                conversationClientId: this.state.conversationClientId,
                conversationClientSecret: this.state.conversationClientSecret,
                voiceClientId: this.state.voiceClientId,
                voiceClientSecret: this.state.voiceClientSecret,
                sftpPrivateKeyUpload: sftpPrivateUploadValue,
                sftpPrivateKeyGenerated: sftpPrivateKeyFileContentValue
            },
        });

        const status = result.data.checkExportConnectionString;

        const responses = {
            EmptyConnectionString: {
                border: "1px solid red",
                error: "Storage connection string cannot be empty. Please provide a valid connection string.",
                toast: () => toast.error("Storage connection string is required and cannot be empty", { autoClose: 5000, position: "bottom-left" }),
                valid: "false"
            },
            MissingValueFromConnectionString: {
                border: "1px solid red",
                error: "Connection string is missing required values. Please check the format and ensure all necessary parameters are included.",
                toast: () => toast.error("Connection string is incomplete. Missing required parameters.", { autoClose: 5000, position: "bottom-left" }),
                valid: "false"
            },
            InvalidFormat: {
                border: "1px solid red",
                error: "Connection string format is invalid. Please verify the syntax and parameter names.",
                toast: () => toast.error("Invalid connection string format, please check syntax", { autoClose: 5000, position: "bottom-left" }),
                valid: "false"
            },
            InaccesibleResource: {
                border: "1px solid red",
                error: "Unable to access the storage resource. Please verify your connection string and ensure the resource is available.",
                toast: () => toast.error("Storage resource is inaccessible, check connection and permissions", { autoClose: 5000, position: "bottom-left" }),
                valid: "false"
            },
            Valid: {
                border: "1px solid green",
                error: "",
                toast: () => toast.success("Storage connection string is valid", { autoClose: 5000, position: "bottom-left" }),
                valid: "true"
            },
            UnknownError: {
                border: "1px solid red",
                error: "An unexpected error occurred while validating the connection string. Please try again.",
                toast: () => toast.error("Validation failed due to an unexpected error, please try again", { autoClose: 5000, position: "bottom-left" }),
                valid: "false"
            },
            SftpAuthenticationError: {
                border: "1px solid red",
                error: "SFTP authentication failed. Please verify your username, password, or private key credentials.",
                toast: () => toast.error("SFTP authentication failed. Please check your credentials.", { autoClose: 5000, position: "bottom-left" }),
                valid: "false"
            },
            SftpSSHConnectionError: {
                border: "1px solid red",
                error: "Unable to establish an SSH connection to the SFTP server. Please verify the host address and port.",
                toast: () => toast.error("SSH connection to SFTP server failed. Please check host and port.", { autoClose: 5000, position: "bottom-left" }),
                valid: "false"
            },
            SftpSocketError: {
                border: "1px solid red",
                error: "Network connection to the SFTP server failed. Please verify the server is reachable and the port is open.",
                toast: () => toast.error("Network connection to SFTP server failed. Please verify the server is reachable.", { autoClose: 5000, position: "bottom-left" }),
                valid: "false"
            }
        };

        // RI-19683: never leave the check in "pending" on an unmapped status, that
        // would keep the save button disabled with no way to recover.
        const response = responses[status] || responses.UnknownError;
        if (response) {
            // Only style button and error for GlobalRelay, otherwise style all
            if (this.state.exportType === "GlobalRelay") {
                if (checkBtnEl) checkBtnEl.style.border = response.border;
            } else {
                [storageConnectionStringEl, storageContainerNameEl, checkBtnEl].forEach(el => el && (el.style.border = response.border));
            }
            if (errorEl) {
                // RI-19683: the check still fails, but the job can be saved anyway.
                errorEl.innerHTML = response.valid === "false"
                    ? `${response.error} The export job can still be saved.`
                    : response.error;
            }
            response.toast();
            this.setState({ validateStorageConnectionString: response.valid });
        }
    };

    handleSubTypeMappingChange = key => (event, newValue, checked) => {
        this.setState(prevState => {
            const updatedMapping = { ...prevState.subTypeMapping };
            if (!checked) {
                delete updatedMapping[key];
            } else {
                updatedMapping[key] = newValue;
            }
            return { subTypeMapping: updatedMapping };
        });
    };

    createPublicKey = async () => {
        this.setState({ publicKeyLoading: true, publicKeyText: "creatingKey" });
        try {

            const result = await this.props.apol.mutate({
                mutation: mutationCreatePublicKey,
                variables: { input: this.props.authorization, password: this.state.publicKeyPassword }
            });
            const content = result.data.createPublicKey;
            if (content) {
                this.setState({
                    sftpPublicKeyFileContent: content.sftpPublicKey,
                    sftpPrivateKeyFileContent: content.sftpPrivateKey,
                    publicKeyText: "downloadPublicKey",
                    publicKeyLoading: false
                });
            } else {
                throw new Error("Failed to create public key");
            }
        } catch (err) {
            toast.error("Error creating public key", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            })

            this.setState({
                publicKeyText: "createPublicKey",
                publicKeyLoading: false
            });
        }
    };

    downloadPublicKey = () => {
        if (this.state.sftpPublicKeyFileContent) {
            const blob = new Blob([this.state.sftpPublicKeyFileContent], { type: "text/plain" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = "public_key.pem";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }
    };
    // --------------------------------------

    render() {
        return (
            <MyContext.Consumer>
                {(context) => (
                    <Stack vertical>
                        {/* rule name */}
                        <TextField type={"text"}
                            label={context.getTranslation("configuration", "jobName")}
                            value={this.state.name}
                            onChange={(event, newValue) => {
                                this.setState({ name: newValue });
                            }}
                            errorMessage={this.state.name == "" ? "Rule name cannot be empty" : ""}
                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                        />

                        <Toggle
                            defaultChecked={this.state.enabled}
                            label={context.getTranslation("settings", "enabled")}
                            onText={context.getTranslation("settings", "on")}
                            offText={context.getTranslation("settings", "off")}
                            onChange={(ev, checked) => {
                                this.setState({
                                    enabled: checked,
                                    updated: true
                                });
                            }}
                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                        />

                        <br />
                        <hr />

                        <Label alignContent="start">{context.getTranslation("configuration", "interval")}</Label>

                        <ChoiceGroup
                            selectedKey={this.state.intervalType}
                            style={{ width: "200px" }}
                            options={[
                                {
                                    key: 'OneTime',
                                    text: context.getTranslation("configuration", "single"),
                                    'data-automation-id': 'auto1',
                                    styles: { field: { fontWeight: FontWeights.regular } }
                                },
                                {
                                    key: 'Periodical',
                                    text: context.getTranslation("configuration", "periodical"),
                                    styles: { field: { fontWeight: FontWeights.regular } }
                                },
                                {
                                    key: 'Push',
                                    text: context.getTranslation("configuration", "push"),
                                    styles: { field: { fontWeight: FontWeights.regular } }
                                }
                            ]}
                            onChange={(event, newValue) => {
                                const isPush = newValue.key === 'Push';
                                const pushExportTypes = this.exportTypePushOptions.map(opt => opt.key);
                                const resetExportType = isPush && !pushExportTypes.includes(this.state.exportType);
                                this.setState({
                                    intervalType: newValue.key,
                                    intervalMinute: newValue.key === 'Periodical' ? 30 : 0,
                                    exportType: resetExportType ? "Blobstorage" : this.state.exportType,
                                    updated: true
                                });
                            }}
                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                        />

                        <Stack.Item>
                            {this.state.intervalType !== "Push" && <>
                                <Label>{context.getTranslation("configuration", "startTime")}</Label>

                                <DateTimePicker
                                    locale={this.props.authorization.locale}
                                    calendarClassName={this.props.theme.palette.black < "#100000" ? "Light" : "Dark"}

                                    firstDayOfWeek={1}
                                    value={this.state.jobStartTime ? new Date(this.state.jobStartTime) : null}
                                    onChange={(date) => {
                                        if (date === null) {
                                            this.setState({
                                                jobStartTime: null
                                            });
                                            return;
                                        }
                                        let parsedDate = new Date(date);
                                        if (parsedDate < new Date("0001-01-01T00:00:00Z")) {
                                            parsedDate = new Date("0001-01-01T00:00:00Z")
                                        }
                                        else if (parsedDate > new Date("9999-12-31T23:59:59Z")) {
                                            parsedDate = new Date("9999-12-31T23:59:59Z")
                                        }

                                        this.setState({
                                            jobStartTime: parsedDate
                                        });
                                    }
                                    }
                                    minDate={new Date("0001-01-01T00:00:00Z")}
                                    maxDate={new Date("9999-12-31T23:59:59Z")}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                            </>}
                        </Stack.Item>
                        {this.state.intervalType == "Periodical" &&
                            <Stack>
                                <Stack.Item>
                                    <Label>{context.getTranslation("configuration", "cycle")}</Label>

                                    <div style={{ diplay: "flex" }}>
                                        <TextField
                                            name="CycleTime"
                                            type="Number"
                                            min={0}

                                            label={context.getTranslation("configuration", "cycleMonth")}
                                            value={this.state.intervalMonth}
                                            onChange={(event, newValue) => {
                                                if (newValue < 0)
                                                    newValue = 0;
                                                this.setState({
                                                    intervalMonth: parseInt(newValue)
                                                })
                                            }}
                                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                        />

                                    </div>

                                    <div style={{ diplay: "flex" }}>
                                        <TextField
                                            name="CycleTime"
                                            type="Number"
                                            min={0}

                                            label={context.getTranslation("configuration", "cycleDay")}
                                            value={this.state.intervalDay}
                                            onChange={(event, newValue) => {
                                                if (newValue < 0)
                                                    newValue = 0;
                                                this.setState({
                                                    intervalDay: parseInt(newValue)
                                                })
                                            }}
                                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                        />

                                    </div>

                                    <div style={{ diplay: "flex" }}>
                                        <TextField
                                            name="CycleTime"
                                            type="Number"
                                            min={0}

                                            label={context.getTranslation("configuration", "cycleHour")}
                                            value={this.state.intervalHour}
                                            onChange={(event, newValue) => {
                                                if (newValue < 0)
                                                    newValue = 0;
                                                this.setState({
                                                    intervalHour: parseInt(newValue),
                                                })
                                            }}
                                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                        />

                                    </div>

                                    <div style={{ diplay: "flex" }}>
                                        <TextField
                                            name="CycleTime"
                                            type="Number"
                                            min={30}
                                            step="30"
                                            onKeyPress={(e) => e.preventDefault()}
                                            label={context.getTranslation("configuration", "cycleMinute")}
                                            value={this.state.intervalMinute}
                                            onChange={(event, newValue) => {
                                                if (newValue < 0)
                                                    newValue = 0;
                                                this.setState({
                                                    intervalMinute: parseInt(newValue)
                                                })
                                            }}
                                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                        />

                                    </div>

                                </Stack.Item>
                            </Stack>
                        }
                        <br />
                        <hr />
                        <Stack.Item>
                            {/* target storage */}
                            <ComboBox
                                style={{ width: "300px" }}
                                placeholder="Select an option"
                                label={context.getTranslation("configuration", "exportType")}
                                options={this.state.intervalType === "Push" ? this.exportTypePushOptions : this.exportTypeOptions}
                                selectedKey={this.state.exportType}
                                onChange={(ev, newVal) => {
                                    const allowedMetadataCheck = ["Blobstorage", "Hubstor", "SFTP", "AWS"];//make sure metadata is true for other exports where is not editable
                                    this.setState({
                                        exportType: newVal.key,
                                        isValidUUID: true,
                                        updated: true,
                                        storageConnectionString: "",
                                        storageContainerName: "",
                                        storageRootDirectory: "",
                                        exportMetadata: allowedMetadataCheck.includes(newVal.key) ? this.state.exportMetadata : true,
                                    });
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                            />
                        </Stack.Item>

                        {this.state.exportType === "AWS" && <Stack.Item>

                            <Query
                                query={queryGetAWSRegions}
                                variables={this.props.authorization} >
                                {({ loading, error, data }) => {
                                    if (loading) return <div>
                                        <Spinner label={context.getTranslation("common", "loadingRegions")} ariaLive="assertive" labelPosition="top" />
                                    </div>;
                                    if (error) return <h1> </h1>;

                                    if (data.getAWSRegions == null) {
                                        return <div></div>;
                                    }
                                    this.tmpKey = [];
                                    const stack = data.getAWSRegions;
                                    if (data.getAWSRegions != null) {
                                        for (let x = 0; x < stack.length; x++) {
                                            let i = {
                                                key: stack[x].code,
                                                text: stack[x].displayName,
                                            };
                                            this.tmpKey.push(i);
                                        }
                                    }

                                    return <ComboBox
                                        style={{ width: "300px" }}
                                        placeholder="Select an option"
                                        label={context.getTranslation("configuration", "defaultRegion")}
                                        options={this.tmpKey}
                                        selectedKey={this.state.defaultRegion}
                                        onChange={(ev, newVal) => {
                                            this.setState({
                                                defaultRegion: newVal.key,
                                                updated: true
                                            });
                                        }}
                                        errorMessage={this.state.defaultRegion == "" ? "Default region must be selected" : ""}
                                        disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                    />
                                }}
                            </Query>



                        </Stack.Item>
                        }
                        {(this.state.exportType === "AWS" || this.state.exportType === "SurveilX" || this.state.exportType === "SFTP") && (<Stack>
                            <Checkbox
                                label={context.getTranslation("configuration", "pgpEncryption")}
                                checked={this.state.PGPEncryption}
                                styles={checkboxStyles}
                                onChange={(ev, newVal) => {
                                    this.setState({
                                        PGPEncryption: newVal,
                                        updated: true
                                    });
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                            />

                            {this.state.PGPEncryption && <>

                                <div id="clickable-area">
                                    <input type="file" onChange={this.onFileChangePGP} id="file-btn" disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false} />
                                    <div className="upload-button"><span>{this.state.selectedFile ? context.getTranslation("common", "updateFile") : context.getTranslation("common", "uploadFile")}</span>
                                    </div><p id="clickable-area-text">{this.state.selectedFile
                                        ? <i className="ms-Icon ms-Icon--Accept" style={{ fontSize: "20px" }}></i>
                                        : context.getTranslation("common", "noFileSelected")} &nbsp;</p>
                                </div>
                            </>}

                        </Stack>)}

                        {(this.state.exportType === "AuditLogSFTPCustom" || this.state.exportType === "AuditEvent") &&
                            <Stack.Item>
                                <ComboBox
                                    label={context.getTranslation("configuration", "auditLogType")}
                                    selectedKey={this.state.auditEventTypes}
                                    allowFreeform={false}
                                    onChange={this.onChangeMulti}
                                    autoComplete={true}
                                    options={this.auditLogTypesOptions}
                                    style={{ width: "300px" }}
                                    multiSelect
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                            </Stack.Item>}
                        {/* audio codec */}
                        {(this.state.exportType !== "AuditLogSFTPCustom" && this.state.exportType !== "eKontakt" && this.state.exportType !== "AuditEvent") &&
                            <Stack.Item>
                                <ComboBox
                                    style={{ width: "300px" }}
                                    placeholder={context.getTranslation("common", "selectAnOption")}
                                    label={context.getTranslation("configuration", "audioFormat")}
                                    options={[{
                                        key: "NONE",
                                        text: context.getTranslation("configuration", "keepCurrent")
                                    },
                                    {
                                        key: "WAV",
                                        text: "WAV",
                                    },
                                    {
                                        key: "MP3",
                                        text: "MP3",
                                    }]
                                    }
                                    selectedKey={this.state.audioCodec}
                                    onChange={(ev, newVal) => {
                                        this.setState({
                                            audioCodec: newVal.key,
                                            updated: true
                                        });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                />
                            </Stack.Item>}

                        <br />
                        <hr />
                        {(["eKontakt", "AuditLogSFTPCustom", "AuditEvent", "SFTP", "SurveilX"].includes(this.state.exportType)) && (
                            <Stack>
                                <ChoiceGroup
                                    label={context.getTranslation("configuration", "keySetupMethod")}
                                    selectedKey={this.state.keyOption}
                                    options={[
                                        {
                                            key: "generate", text: context.getTranslation("configuration", "generatePublicKey"),
                                            styles: { field: { fontWeight: FontWeights.regular } }
                                        },
                                        {
                                            key: "upload", text: context.getTranslation("configuration", "privateKeyUpload"),
                                            styles: { field: { fontWeight: FontWeights.regular } }
                                        }
                                    ]}
                                    onChange={(_, option) => this.setState({ keyOption: option.key })}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                                {this.state.keyOption === "generate" && (
                                    <>
                                        <Stack.Item>
                                            <TextField
                                                label={<MyContext.Consumer>{(context) => <> {context.getTranslation("configuration", "passwordOptional")}</>}</MyContext.Consumer>}
                                                type={this.state.showPublicKeyPassword ? "text" : "password"}
                                                value={this.state.publicKeyPassword}
                                                onChange={(e, newValue) => this.setState({ publicKeyPassword: newValue })}
                                                canRevealPassword
                                                revealPasswordAriaLabel="Show password"
                                                disabled={this.state.publicKeyLoading}
                                            />
                                        </Stack.Item>
                                        <Stack.Item>
                                            <TextField
                                                label={<MyContext.Consumer>{(context) => <> {context.getTranslation("configuration", "sftpPrivateKeyKeyVaultUrl")}</>}</MyContext.Consumer>}
                                                value={this.state.sftpPrivateKeyKeyVaultUrl || ""}
                                                onChange={(e, newValue) => this.setState({ sftpPrivateKeyKeyVaultUrl: newValue })}
                                                disabled={this.state.publicKeyLoading}
                                            />
                                        </Stack.Item>
                                        <Stack.Item>
                                            <TextField
                                                label={<MyContext.Consumer>{(context) => <> {context.getTranslation("configuration", "sftpPrivateKeyKeyVaultSecretName")}</>}</MyContext.Consumer>}
                                                value={this.state.sftpPrivateKeyKeyVaultSecretName || ""}
                                                onChange={(e, newValue) => this.setState({ sftpPrivateKeyKeyVaultSecretName: newValue })}
                                                disabled={this.state.publicKeyLoading}
                                            />
                                        </Stack.Item>
                                        <Stack.Item>
                                            <DefaultButton
                                                id="publicKeyBtn"
                                                style={{ marginTop: "5px" }}
                                                text={<MyContext.Consumer>{(context) => <> {context.getTranslation("configuration", this.state.publicKeyText)}</>}</MyContext.Consumer>}
                                                onClick={
                                                    this.state.sftpPublicKeyFileContent
                                                        ? this.downloadPublicKey
                                                        : this.createPublicKey
                                                }
                                                disabled={this.state.publicKeyLoading}
                                            />
                                        </Stack.Item>
                                        <br />
                                        <hr />
                                    </>
                                )}
                                {this.state.keyOption === "upload" && (
                                    <Stack.Item>
                                        <br />
                                        <div id="clickable-area">
                                            <input type="file" onChange={this.onFileChangeSftp} id="file-btn" disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false} />
                                            <div className="upload-button"><span>{this.state.hasSftpKey ? context.getTranslation("common", "updateFile") : context.getTranslation("common", "uploadFile")}</span>
                                            </div><p id="clickable-area-text">{this.state.sftpPrivateKeyUpload
                                                ? <i className="ms-Icon ms-Icon--Accept" style={{ fontSize: "20px" }}></i>
                                                : context.getTranslation("common", "noFileSelected")} &nbsp;</p>
                                        </div>
                                        <hr />
                                    </Stack.Item>

                                )}
                            </Stack>
                        )}

                        {/* export connection string */}

                        <Stack.Item>
                            {(this.state.exportType !== "NeoTransfer" && this.state.exportType !== "GlobalRelay") && <>
                                <Label>{context.getTranslation("configuration", "storage")}</Label>
                                <TextField label={context.getTranslation("configuration", "storageConnectionString")}
                                    id="storageConnectionString"
                                    value={this.state.storageConnectionString}
                                    onChange={(event, newValue) => {
                                        this.setState({ storageConnectionString: newValue, validateStorageConnectionString: "", storageConnectionStringChanged: true });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                />
                                <span style={{ marginLeft: "9px", fontSize: "smaller", fontStyle: "italic" }}>{this.storageConnectionStringPlaceHolder()}</span>


                            </>}

                            {this.state.exportType === "GlobalRelay" && <>
                                <TextField
                                    label={context.getTranslation("configuration", "conversationClientId")}
                                    value={this.state.conversationClientId}
                                    onChange={(event, newValue) => this.setState({ conversationClientId: newValue })}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                                <TextField
                                    label={context.getTranslation("configuration", "conversationClientSecret")}
                                    value={this.state.conversationClientSecret}
                                    onChange={(event, newValue) => this.setState({ conversationClientSecret: newValue })}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                                <TextField
                                    label={context.getTranslation("configuration", "voiceClientId")}
                                    value={this.state.voiceClientId}
                                    onChange={(event, newValue) => this.setState({ voiceClientId: newValue })}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                                <TextField
                                    label={context.getTranslation("configuration", "voiceClientSecret")}
                                    value={this.state.voiceClientSecret}
                                    onChange={(event, newValue) => this.setState({ voiceClientSecret: newValue })}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                            </>}
                            {(this.state.exportType !== "SurveilX" && this.state.exportType !== "NeoTransfer" && this.state.exportType !== "GlobalRelay") && <>
                                <TextField label={context.getTranslation("configuration", "storageContainerName")}
                                    id="storageContainerName"
                                    value={this.state.storageContainerName}
                                    onChange={(event, newValue) => {
                                        this.setState({ storageContainerName: newValue });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                /></>
                            }
                            <span id="storageConnectionStringError" style={{ color: "red", marginTop: "10px" }}></span>
                            {this.state.exportType !== "NeoTransfer" && <>
                                <br />
                                <DefaultButton
                                    id="checkBtn"
                                    style={{ marginTop: "5px" }}
                                    text={<MyContext.Consumer>{(context) => <> {context.getTranslation("dashboard", "checkValidity")}</>}</MyContext.Consumer>}
                                    onClick={(event) => {
                                        this.checkStorageConnectionString();
                                    }}
                                    disabled={this.state.validateStorageConnectionString == "pending" || (this.state.storageConnectionString === "******" && !this.state.storageConnectionStringChanged)}
                                /></>}

                            {(this.state.exportType !== "Neo" && this.state.exportType !== "SurveilX" && this.state.exportType !== "NeoTransfer" && this.state.exportType !== "GlobalRelay") &&
                                <TextField label={context.getTranslation("configuration", "storageRootDirectory")}
                                    value={this.state.storageRootDirectory}
                                    onChange={(event, newValue) => {
                                        this.setState({ storageRootDirectory: newValue });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                />
                            }
                        </Stack.Item>

                        {this.state.exportType === "Neo" && <Stack.Item>
                            <TextField label={context.getTranslation("configuration", "keyVaultUrl")}
                                value={this.state.encryptionKeyVaultUrl}
                                onChange={(event, newValue) => {
                                    this.setState({
                                        encryptionKeyVaultUrl: newValue,
                                    });
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                            />
                        </Stack.Item>}


                        {this.state.exportType === "NeoTransfer" &&
                            <Stack.Item>

                                <TextField label={context.getTranslation("configuration", "transferId")}
                                    value={this.state.transferId}
                                    onChange={this.handleTransferIdChange}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                    placeholder={context.getTranslation("configuration", "newTransfer")}
                                    errorMessage={!this.state.isValidUUID ? context.getTranslation("configuration", "errorNewTransfer") : ""}

                                />
                                {this.props.data !== null &&
                                    <DefaultButton
                                        onClick={this.downloadNeoTransferFile}
                                        text={context.getTranslation("configuration", this.state.downloadNeoTransferTextBtn)}
                                        disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                        style={{ marginTop: "10px" }}
                                    />}

                            </Stack.Item>
                        }
                        <br />

                        {this.state.exportType == "GlobalRelay" && <>
                            <hr />
                            <Stack horizontal tokens={{ childrenGap: 16 }} verticalAlign="end">
                                <ComboBox
                                    label={context.getTranslation("configuration", "customfield")}
                                    placeholder={context.getTranslation("common", "selectAnOption")}
                                    options={(this.state.customFieldOptions || []).map(item => ({ key: item.id, text: item.fieldName }))}
                                    selectedKey={this.state.customFieldKey}
                                    style={{ width: 200 }}
                                    allowFreeform
                                    autoComplete="on"
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                    onChange={(ev, newVal) => {
                                        this.setState({
                                            customFieldKey: newVal.key
                                        });
                                    }}
                                />
                                <TextField
                                    label={context.getTranslation("detailContainer", "value")}
                                    placeholder={context.getTranslation("common", "enterValue")}
                                    value={this.state.customFieldValue}
                                    style={{ width: 200 }}
                                    onChange={(event, newValue) => {
                                        this.setState({ customFieldValue: newValue });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                                <Toggle
                                    label={context.getTranslation("configuration", "operator")}
                                    onText="Equal"
                                    offText="Not Equal"
                                    checked={this.state.isCustomFieldEqual}
                                    onChange={(ev, checked) => {
                                        this.setState({ isCustomFieldEqual: checked });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                            </Stack>
                            <br />
                        </>}
                        {(this.state.exportType !== "AuditLogSFTPCustom" && this.state.exportType !== "AuditEvent") && <>
                            <hr />
                            <Label>{context.getTranslation("configuration", "retentionTimeAfterExport")}</Label>
                            <Toggle
                                defaultChecked={this.state.sourceTtlEnabled}
                                onText={context.getTranslation("settings", "on")}
                                offText={context.getTranslation("settings", "off")}
                                onChange={(ev, checked) => {
                                    this.setState({
                                        sourceTtl: checked ? 10 : -1,
                                        sourceTtlEnabled: checked,
                                        updated: true
                                    });
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                            />
                        </>}
                        {this.state.sourceTtlEnabled && < TextField
                            value={this.state.sourceTtl}
                            type="Number"
                            label={context.getTranslation("configuration", "retentionTimeAfterExportDays")}
                            onChange={(event, newValue) => {
                                if(newValue < 0)
                                    newValue = 0;

                                this.setState({
                                    sourceTtl: parseInt(newValue),
                                });
                            }}
                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                        />}
                        <br />
                        <hr />

                        {/*merge audio into video*/}
                        {!["Bloomberg", "eKontakt", "AuditLogSFTPCustom", "Neo", "AuditEvent", "SurveilX"].includes(this.state.exportType) && <>
                            <Stack.Item>
                                <Label>{context.getTranslation("configuration", "exportSettings")}</Label>

                                {this.state.intervalType !== "Push" &&
                                    <Checkbox
                                        label={context.getTranslation("configuration", "mergeAudioToVideo")}
                                        checked={this.state.mergeAudioToVideo}
                                        styles={checkboxStyles}
                                        onChange={(ev, newVal) => {
                                            this.setState({
                                                mergeAudioToVideo: newVal,
                                                updated: true
                                            });
                                        }}
                                    />
                                }

                                {!["GlobalRelay"].includes(this.state.exportType) &&

                                    <Checkbox
                                        label={context.getTranslation("configuration", "conversationFilterMetadataTranscript")}
                                        checked={this.state.metadataInTranscript}
                                        styles={checkboxStyles}
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                metadataInTranscript: newValue,
                                                updated: true
                                            });
                                        }}
                                    />
                                }

                            </Stack.Item>
                            <br />
                            <hr />
                        </>
                        }



                        <Label alignContent="start">{context.getTranslation("configuration", "filter")}</Label>



                        {/* media type */}
                        {(this.state.exportType !== "AuditLogSFTPCustom" && this.state.exportType !== "eKontakt" && this.state.exportType !== "AuditEvent") && <Stack.Item>
                            <Label>{context.getTranslation("configuration", "mediaTypes")}</Label>
                            <Checkbox
                                label={context.getTranslation("configuration", "conversationFilterMetaData")}
                                checked={this.state.exportMetadata}
                                onChange={(event, newValue) => {
                                    this.setState({
                                        exportMetadata: newValue,
                                        updated: true
                                    });
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) || !["Blobstorage", "Hubstor", "SFTP", "AWS"].includes(this.state.exportType)}
                            />

                            <Checkbox
                                label={context.getTranslation("configuration", "conversationFilterAudio")}
                                checked={this.state.mediaType & 1}
                                onChange={(event, checked) => {
                                    this.setState({
                                        mediaType: checked ? this.state.mediaType | 1 : this.state.mediaType - 1,
                                        updated: true
                                    });
                                    if (this.state.exportType === "GlobalRelay") {
                                        this.handleSubTypeMappingChange("Audio")(event, this.state.subTypeMapping.Audio, checked);
                                    }
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                            />
                            {this.state.exportType === "GlobalRelay" && (this.state.mediaType & 1) ? (
                                <TextField
                                    placeholder={context.getTranslation("configuration", "subTypeMapping")}
                                    value={this.state.subTypeMapping.Audio || ""}
                                    onChange={(event, newValue) => this.handleSubTypeMappingChange("Audio")(event, newValue, true)}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                    styles={textFieldIndentStyles}
                                />
                            ) : null}
                            {this.state.exportType !== "SurveilX" && this.state.intervalType !== "Push" && <>
                                <Checkbox
                                    label={context.getTranslation("configuration", "conversationFilterVideo")}
                                    checked={this.state.mediaType & 2}
                                    onChange={(event, checked) => {
                                        this.setState({
                                            mediaType: checked ? this.state.mediaType | 2 : this.state.mediaType - 2,
                                            updated: true
                                        });
                                        if (this.state.exportType === "GlobalRelay") {
                                            this.handleSubTypeMappingChange("VideoForUser")(event, this.state.subTypeMapping.VideoForUser, checked);
                                        }
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                                {this.state.exportType === "GlobalRelay" && (this.state.mediaType & 2) ? (
                                    <TextField
                                        placeholder={context.getTranslation("configuration", "subTypeMapping")}
                                        value={this.state.subTypeMapping.VideoForUser || ""}
                                        onChange={(event, newValue) => this.handleSubTypeMappingChange("VideoForUser")(event, newValue, true)}
                                        disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                        styles={textFieldIndentStyles}

                                    />
                                ) : null}
                                <Checkbox
                                    label={context.getTranslation("configuration", "conversationFilterScreenSharing")}
                                    checked={this.state.mediaType & 4}
                                    onChange={(event, checked) => {
                                        this.setState({
                                            mediaType: checked ? this.state.mediaType | 4 : this.state.mediaType - 4,
                                            updated: true
                                        });
                                        if (this.state.exportType === "GlobalRelay") {
                                            this.handleSubTypeMappingChange("VideoBasedScreenSharing")(event, this.state.subTypeMapping.VideoBasedScreenSharing, checked);
                                        }
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                                {this.state.exportType === "GlobalRelay" && (this.state.mediaType & 4) ? (
                                    <TextField
                                        placeholder={context.getTranslation("configuration", "subTypeMapping")}
                                        value={this.state.subTypeMapping.VideoBasedScreenSharing || ""}
                                        onChange={(event, newValue) => this.handleSubTypeMappingChange("VideoBasedScreenSharing")(event, newValue, true)}
                                        disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                        styles={textFieldIndentStyles}

                                    />
                                ) : null}
                                <Checkbox
                                    label={context.getTranslation("configuration", "conversationFilterUserScreen")}
                                    checked={this.state.mediaType & 256}
                                    onChange={(event, checked) => {
                                        this.setState({
                                            mediaType: checked ? this.state.mediaType | 256 : this.state.mediaType - 256,
                                            updated: true
                                        });
                                        if (this.state.exportType === "GlobalRelay") {
                                            this.handleSubTypeMappingChange("UserScreen")(event, this.state.subTypeMapping.UserScreen, checked);
                                        }
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                                {this.state.exportType === "GlobalRelay" && (this.state.mediaType & 256) ? (
                                    <TextField
                                        placeholder={context.getTranslation("configuration", "subTypeMapping")}
                                        value={this.state.subTypeMapping.UserScreen || ""}
                                        onChange={(event, newValue) => this.handleSubTypeMappingChange("UserScreen")(event, newValue, true)}
                                        disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                        styles={textFieldIndentStyles}

                                    />
                                ) : null}
                                <Checkbox
                                    label={context.getTranslation("configuration", "conversationFilterUpload")}
                                    checked={this.state.mediaType & 8}
                                    onChange={(event, checked) => {
                                        this.setState({
                                            mediaType: checked ? this.state.mediaType | 8 : this.state.mediaType - 8,
                                            updated: true
                                        });
                                        if (this.state.exportType === "GlobalRelay") {
                                            this.handleSubTypeMappingChange("Upload")(event, this.state.subTypeMapping.Upload, checked);
                                        }
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                                {this.state.exportType === "GlobalRelay" && (this.state.mediaType & 8) ? (
                                    <TextField
                                        placeholder={context.getTranslation("configuration", "subTypeMapping")}
                                        value={this.state.subTypeMapping.Upload || ""}
                                        onChange={(event, newValue) => this.handleSubTypeMappingChange("Upload")(event, newValue, true)}
                                        disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                        styles={textFieldIndentStyles}

                                    />
                                ) : null}
                                <Checkbox
                                    label={context.getTranslation("configuration", "conversationFilterDocuments")}
                                    checked={this.state.mediaType & 16}
                                    onChange={(event, checked) => {
                                        this.setState({
                                            mediaType: checked ? this.state.mediaType | 16 : this.state.mediaType - 16,
                                            updated: true
                                        });
                                        if (this.state.exportType === "GlobalRelay") {
                                            this.handleSubTypeMappingChange("File")(event, this.state.subTypeMapping.File, checked);
                                        }
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                                {this.state.exportType === "GlobalRelay" && (this.state.mediaType & 16) ? (
                                    <TextField
                                        placeholder={context.getTranslation("configuration", "subTypeMapping")}
                                        value={this.state.subTypeMapping.File || ""}
                                        onChange={(event, newValue) => this.handleSubTypeMappingChange("File")(event, newValue, true)}
                                        disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                        styles={textFieldIndentStyles}

                                    />
                                ) : null}
                            </>}
                            <Checkbox
                                label={context.getTranslation("configuration", "conversationFilterChat")}
                                checked={this.state.mediaType & 32}
                                onChange={(event, checked) => {
                                    this.setState({
                                        mediaType: checked ? this.state.mediaType | 32 : this.state.mediaType - 32,
                                        updated: true
                                    });
                                    if (this.state.exportType === "GlobalRelay") {
                                        this.handleSubTypeMappingChange("Chat")(event, this.state.subTypeMapping.Chat, checked);
                                    }
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                            />
                            {this.state.exportType === "GlobalRelay" && (this.state.mediaType & 32) ? (
                                <TextField
                                    placeholder={context.getTranslation("configuration", "subTypeMapping")}
                                    value={this.state.subTypeMapping.Chat || ""}
                                    onChange={(event, newValue) => this.handleSubTypeMappingChange("Chat")(event, newValue, true)}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                    styles={textFieldIndentStyles}

                                />
                            ) : null}
                            {!["GlobalRelay", "SurveilX"].includes(this.state.exportType) && <>

                                <Checkbox
                                    label={context.getTranslation("configuration", "conversationFilterTranscript")}
                                    checked={this.state.mediaType & 64}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            mediaType: newValue ? this.state.mediaType | 64 : this.state.mediaType - 64,
                                            updated: true
                                        });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                />
                            </>}
                        </Stack.Item>}

                        {/*policy results type*/}
                        {["Blobstorage", "Hubstor", "SFTP", "AWS"].includes(this.state.exportType) && (
                            <>
                                <br />
                                <hr />
                                <Stack.Item>
                                    <Label style={{ fontWeight: 600, marginTop: 16, marginBottom: 8 }}>
                                        Policy Results
                                    </Label>
                                    {this.policyResultTypesOptions.map(opt => (
                                        <Checkbox
                                            key={opt.key}
                                            label={context.getTranslation("configuration", opt.text)}
                                            checked={this.isPolicyResultTypeChecked(opt.key)}
                                            onChange={(e, checked) => this.handlePolicyResultTypeChange(opt.key, checked)}
                                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                            styles={checkboxStyles}
                                        />
                                    ))}
                                </Stack.Item>
                                <br />
                                <hr />
                            </>
                        )}


                        {/* timeframe */}
                        {this.state.intervalType !== "Push" && <Stack.Item>
                            <Label>{context.getTranslation("configuration", "startTime")}</Label>

                            <DateTimePicker
                                locale={this.props.authorization.locale}
                                calendarClassName={this.props.theme.palette.black < "#100000" ? "Light" : "Dark"}
                                firstDayOfWeek={1}
                                value={this.state.callStartTime ? new Date(this.state.callStartTime) : null}
                                onChange={(date) => {
                                    if (date === null) {
                                        this.setState({
                                            callStartTime: null,
                                            callDateError: ''
                                        });
                                        return;
                                    }
                                    let parsedDate = new Date(date);
                                    if (parsedDate < new Date("0001-01-01T00:00:00Z")) {
                                        parsedDate = new Date("0001-01-01T00:00:00Z")
                                    }
                                    else if (parsedDate > new Date("9999-12-31T23:59:59Z")) {
                                        parsedDate = new Date("9999-12-31T23:59:59Z")
                                    }

                                    if (this.state.callEndTime && parsedDate > new Date(this.state.callEndTime)) {
                                        this.setState({
                                            callDateError: "startDateBeforeEndDate",
                                            callStartTime: null,
                                        });
                                    } else {
                                        this.setState({
                                            callStartTime: parsedDate,
                                            callDateError: ''
                                        });
                                    }
                                }
                                }
                                minDate={new Date("0001-01-01T00:00:00Z")}
                                maxDate={new Date("9999-12-31T23:59:59Z")}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                            />

                            <Label>{context.getTranslation("configuration", "endTime")}</Label>

                            <DateTimePicker
                                locale={this.props.authorization.locale}
                                calendarClassName={this.props.theme.palette.black < "#100000" ? "Light" : "Dark"}
                                firstDayOfWeek={1}
                                value={this.state.callEndTime ? new Date(this.state.callEndTime) : null}
                                onClockOpen={() => this.setState({ callEndIsClockOpen: true })}
                                onClockClose={() => this.setState({ callEndIsClockOpen: false })}
                                onChange={(date) => {
                                    if (date === null) {
                                        this.setState({
                                            callEndTime: null,
                                            callDateError: ''
                                        });
                                        return;
                                    }
                                    let parsedDate = new Date(date);
                                    if (parsedDate < new Date("0001-01-01T00:00:00Z")) {
                                        parsedDate = new Date("0001-01-01T00:00:00Z")
                                    }
                                    else if (parsedDate > new Date("9999-12-31T23:59:59Z")) {
                                        parsedDate = new Date("9999-12-31T23:59:59Z")
                                    }

                                    // Apply 23:59:59 when selecting from calendar (clock not open)
                                    if (!this.state.callEndIsClockOpen) {
                                        parsedDate.setHours(23, 59, 59, 999);
                                    }

                                    if (this.state.callStartTime && parsedDate < new Date(this.state.callStartTime)) {
                                        this.setState({
                                            callDateError: "endDateBeforeStartDate",
                                            callEndTime: null,
                                        });
                                    } else {
                                        this.setState({
                                            callEndTime: parsedDate,
                                            callDateError: ''
                                        });
                                    }
                                }
                                }
                                minDate={new Date("0001-01-01T00:00:00Z")}
                                maxDate={new Date("9999-12-31T23:59:59Z")}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                            />
                            {this.state.callDateError && (
                                <Text style={{ color: '#a80000' }}>{context.getTranslation("filterPanel", this.state.callDateError)}</Text>
                            )}

                        </Stack.Item>}

                        {(this.state.exportType !== "AuditLogSFTPCustom" && this.state.exportType !== "AuditEvent") &&
                            <Stack.Item>
                                <Label>{context.getTranslation("configuration", "userFilter")}</Label>

                                <UserPicker
                                    user={this.state.exportUser}

                                    fc={(user) => {
                                        this.setState({
                                            exportUser: user
                                        });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                />
                            </Stack.Item>}
                        {this.state.intervalType === "Push" && <>
                            <Stack.Item>
                                <Dropdown
                                    multiSelect
                                    selectedKeys={this.state.filterType}
                                    options={this.getSelectOptionsType(context)}
                                    onChange={(event, item) => {
                                        if (item) {
                                            this.setState({
                                                filterType: item.selected ? [...this.state.filterType, item.key] : this.state.filterType.filter(key => key !== item.key),
                                                filterDefaultEnabled: false,
                                                filterUserEnabled: true,
                                                updated: true
                                            });
                                        }
                                    }}
                                    autoComplete={true}
                                    allowFreeform={false}
                                    label={context.getTranslation("filterPanel", "type")}
                                />

                            </Stack.Item>
                            <Stack.Item >
                                <br />
                                <Label>{context.getTranslation("filterPanel", "recordingDuration")}</Label>
                                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                    <div>
                                        <div style={{ display: "inline-block", width: "35%", marginRight: "18px" }}>
                                            <TextField type={"number"}
                                                style={{ border: !this.validateFromTo() ? "2px solid red" : "" }}
                                                label={context.getTranslation("settings", "ticketFrom")}
                                                value={this.state.durationFrom === -1 ? '' : this.state.durationFrom}
                                                onChange={(event, newValue) => {
                                                    //in case user leaves empty will sends -1 and ui displays empty
                                                    //because leaving it 0 instead of empty is confusing
                                                    if (isNaN(newValue) || newValue === "") {
                                                        this.setState({
                                                            durationFrom: parseInt(-1),
                                                            filterDefaultEnabled: false,
                                                            filterUserEnabled: true,
                                                            updated: true
                                                        });
                                                    } else {
                                                        this.setState({
                                                            durationFrom: parseInt(newValue),
                                                            filterDefaultEnabled: false,
                                                            filterUserEnabled: true,
                                                            updated: true
                                                        });
                                                    }
                                                }}
                                                min={0}
                                            />
                                        </div>
                                        <div style={{ display: "inline-block", width: "35%" }}>
                                            <TextField type={"number"}
                                                style={{ border: !this.validateFromTo() ? "2px solid red" : "" }}
                                                label={context.getTranslation("settings", "ticketTo")}
                                                value={this.state.durationTo === -1 ? '' : this.state.durationTo}
                                                onChange={(event, newValue) => {
                                                    //in case user leaves empty will sends -1 and ui displays empty
                                                    //because leaving it 0 instead of empty is confusing
                                                    if (isNaN(newValue) || newValue === "") {
                                                        this.setState({
                                                            durationTo: parseInt(-1),
                                                            filterDefaultEnabled: false,
                                                            filterUserEnabled: true,
                                                            updated: true
                                                        });
                                                    } else {
                                                        this.setState({
                                                            durationTo: parseInt(newValue),
                                                            filterDefaultEnabled: false,
                                                            filterUserEnabled: true,
                                                            updated: true
                                                        });
                                                    }
                                                }}
                                                min={0}

                                            />
                                        </div>
                                    </div>
                                    <span style={{ color: "red" }}>{!this.validateFromTo() ? context.getTranslation("filterPanel", "fromToError") : ""}</span>
                                </div>

                            </Stack.Item>
                            <Stack.Item >
                                <br />
                                <Label>{context.getTranslation("conversationsPage", "participants")}</Label>
                                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                    <div>
                                        <div style={{ display: "inline-block", width: "35%", marginRight: "18px" }}>
                                            <TextField type={"number"}
                                                style={{ border: !this.validateParticipantsFromTo() ? "2px solid red" : "" }}
                                                label={context.getTranslation("settings", "ticketFrom")}
                                                value={this.state.participantCountFrom === -1 ? '' : this.state.participantCountFrom}
                                                onChange={(event, newValue) => {
                                                    if (isNaN(newValue) || newValue === "") {
                                                        this.setState({
                                                            participantCountFrom: parseInt(-1),
                                                            filterDefaultEnabled: false,
                                                            filterUserEnabled: true,
                                                            updated: true
                                                        });
                                                    } else {
                                                        this.setState({
                                                            participantCountFrom: parseInt(newValue),
                                                            filterDefaultEnabled: false,
                                                            filterUserEnabled: true,
                                                            updated: true
                                                        });
                                                    }
                                                }}
                                                min={0}
                                            />
                                        </div>
                                        <div style={{ display: "inline-block", width: "35%" }}>
                                            <TextField type={"number"}
                                                style={{ border: !this.validateParticipantsFromTo() ? "2px solid red" : "" }}
                                                label={context.getTranslation("settings", "ticketTo")}
                                                value={this.state.participantCountTo === -1 ? '' : this.state.participantCountTo}
                                                onChange={(event, newValue) => {
                                                    if (isNaN(newValue) || newValue === "") {
                                                        this.setState({
                                                            participantCountTo: parseInt(-1),
                                                            filterDefaultEnabled: false,
                                                            filterUserEnabled: true,
                                                            updated: true
                                                        });
                                                    } else {
                                                        this.setState({
                                                            participantCountTo: parseInt(newValue),
                                                            filterDefaultEnabled: false,
                                                            filterUserEnabled: true,
                                                            updated: true
                                                        });
                                                    }
                                                }}
                                                min={0}
                                            />
                                        </div>
                                    </div>
                                    <span style={{ color: "red" }}>{!this.validateParticipantsFromTo() ? context.getTranslation("filterPanel", "fromToError") : ""}</span>
                                </div>

                            </Stack.Item>
                        </>}
                        <Query
                            query={getProcessingRegions}
                            variables={this.props.authorization} >
                            {({ loading, error, data }) => {
                                if (loading) return <div>
                                    <Spinner label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "loadingRegions")}</>)}</MyContext.Consumer>} ariaLive="assertive" labelPosition="top" />
                                </div>;
                                if (error) return <h1> </h1>;

                                if (data.getProcessingRegions == null) {
                                    return <div></div>;
                                }

                                this.tmpKey = [];
                                const license = data.getProcessingRegions;
                                if (data.getProcessingRegions != null) {
                                    for (let x = 0; x < license.length; x++) {
                                        let i = {
                                            key: license[x],
                                            text: license[x],
                                        };
                                        this.tmpKey.push(i);
                                    }
                                }


                                return <ComboBox
                                    style={{ width: "300px" }}
                                    placeholder="Select an option"
                                    label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "processingRegion")}</>)}</MyContext.Consumer>}
                                    options={this.tmpKey}
                                    selectedKey={this.state.processingRegion}
                                    onChange={(ev, newVal) => {
                                        this.setState({
                                            processingRegion: newVal.key,
                                            updated: true
                                        });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                />
                            }
                            }

                        </Query>

                        <br />

                        <br />
                        <Stack.Item>
                            {(this.props.data !== null && this.props.data.isArchived)
                                ? <></>
                                : <PrimaryButton onClick={this.savePanel} text={context.getTranslation("common", "save")} disabled={this.isValid()} />

                            }
                            <DefaultButton onClick={this.resetState} text={context.getTranslation("common", "cancel")} />
                            {(this.props.data !== null && !this.state.enabled && !this.props.data.isArchived) &&
                                <DefaultButton style={{ background: "red", color: "white", marginLeft: "5px" }} onClick={this.deleteExportJob} text={context.getTranslation("configuration", "deleteJob")} disabled={this.state.jobDeletionActive} />
                            }
                        </Stack.Item>
                    </Stack>
                )
                }
            </MyContext.Consumer>
        );
    }

    storageConnectionStringPlaceHolder = () => {
        var placeholderText = "";
        switch (this.state.exportType) {
            case "Blobstorage":
                placeholderText = "e.g: AccountName=<name>;AccountKey=<key>;"
                break;
            case "Neo":
                placeholderText = "e.g: AccountName=<name>;AccountKey=<key>;"
                break;
            case "Hubstor":
                placeholderText = "e.g: AccountName=<name>;AccountKey=<key>;"
                break;
            case "Bloomberg":
                placeholderText = "e.g: host = <ip>;port=<port>;username=<username>;password=<password>; voiceuploaddir=/Voice/;reconciliationdir=/Reconciliation/Voice;customString=<customString>"
                break;
            case "SFTP":
                placeholderText = "e.g: host = <ip>;port=<port>;username=<username>;password=<password>; voiceuploaddir=/Voice/"
                break;
            case "AWS":
                placeholderText = "e.g: keyid=<id>;accesskey=<key>"
                break;
            case "eKontakt":
                placeholderText = "e.g: host = <ip>;port=<port>;username=<username>;password=<password>; voiceuploaddir=/Voice/"
                break;
            case "AuditLogSFTPCustom":
                placeholderText = "e.g: host = <ip>;port=<port>;username=<username>;password=<password>; voiceuploaddir=/Voice/"
                break;
            case "azureDatalake":
                placeholderText = "e.g: host=127.0.0.1;port=2222;username=tester;password=password;voiceuploaddir=/Voice/"
                break;
            case "AuditEvent":
                placeholderText = "e.g: host = <ip>;port=<port>;username=<username>;password=<password>; voiceuploaddir=/Voice/"
                break;
            default: break;
        }
        return placeholderText;
    }

    isValid = () => {
        if (this.state.callDateError !== "") {
            return true;
        }
        if (this.state.name == null || this.state.name == "") {

            return true;
        }

        if (this.state.exportType == "AWS" && this.state.defaultRegion === "") {

            return true;
        }
        if (!this.state.isValidUUID) {
            return true
        }
        if (!this.validateFromTo() || !this.validateParticipantsFromTo()) {
            return true;
        }

        // RI-19683: a failed connection string check must no longer block saving.
        // The check still runs and still reports the error, but the export job can
        // be created or updated anyway. Only block while a check is still running.
        if (this.state.validateStorageConnectionString === "pending") {
            return true;
        }

        // Custom field validation for GlobalRelay
        if (
            this.state.exportType === "GlobalRelay" &&
            (
                !this.state.customFieldKey ||
                this.state.customFieldKey === "" ||
                !this.state.customFieldValue ||
                this.state.customFieldValue === ""
            )
        ) {
            return true;
        }

        // SubTypeMapping validation for GlobalRelay
        if (this.state.exportType === "GlobalRelay") {
            const mediaTypeMapping = [
                { bit: 1, key: "Audio" },
                { bit: 2, key: "VideoForUser" },
                { bit: 4, key: "VideoBasedScreenSharing" },
                { bit: 256, key: "UserScreen" },
                { bit: 8, key: "Upload" },
                { bit: 16, key: "File" },
                { bit: 32, key: "Chat" }
            ];
            for (const { bit, key } of mediaTypeMapping) {
                if ((this.state.mediaType & bit) && (!this.state.subTypeMapping[key] || this.state.subTypeMapping[key].trim() === "")) {
                    return true;
                }
            }
        }

        return false;
    }

    resetState = () => {

        this.props.closeModal();

    }

    deleteExportJob = async () => {
        this.setState({ jobDeletionActive: true });

        let exportUserIds = [];
        for (let x = 0; x < this.state.exportUser.length; x++) {
            exportUserIds.push(this.state.exportUser[x].key);
        };

        let defaultRegion = this.state.defaultRegion;
        let pgpEncryption = this.state.PGPEncryption;
        let pgpEncryptionKeyUpload = this.state.pgpEncryptionKeyUpload;

        if (this.state.exportType !== "AWS" && this.state.exportType !== "SurveilX"&& this.state.exportType !== "SFTP") {
            defaultRegion = "";
            pgpEncryption = false;
            pgpEncryptionKeyUpload = "";
        }
        let job =
        {
            id: this.state.id,
            name: this.state.name,
            userIds: exportUserIds,
            sourceTtl: this.state.sourceTtlEnabled ? parseInt(this.state.sourceTtl) : -1,
            storageConnectionString: this.state.storageConnectionString,
            storageContainerName: this.state.storageContainerName,
            storageRootDirectory: this.state.storageRootDirectory,
            conversationType: this.state.mediaType,
            exportType: this.state.exportType,
            policyResultType: this.state.policyResultTypes,
            audioCodec: this.state.audioCodec,
            callStartTime: this.state.callStartTime === '' ? null : this.state.callStartTime,
            callEndTime: this.state.callEndTime === '' ? null : this.state.callEndTime,
            enabled: this.state.enabled ? true : false,
            processingRegion: this.state.processingRegion,
            jobType: {
                intervalType: this.state.intervalType,
                jobStartTime: this.state.jobStartTime === '' ? null : this.state.jobStartTime,
                intervalMonth: this.state.intervalMonth,
                intervalDay: this.state.intervalDay,
                intervalHour: this.state.intervalHour,
                intervalMinute: this.state.intervalMinute
            },
            defaultRegion: defaultRegion,
            pgpEncryption: pgpEncryption,
            pgpEncryptionKeyUpload: pgpEncryptionKeyUpload,
            sftpPrivateKeyUpload: this.state.sftpPrivateKeyUpload,
            auditEventTypes: this.state.auditEventTypes,
            transferId: this.state.transferId,
            encryptionKeyVaultUrl: this.state.encryptionKeyVaultUrl,
            customFieldKey: this.state.customFieldKey,
            customFieldValue: this.state.customFieldValue,
            isCustomFieldEqual: this.state.isCustomFieldEqual,
            conversationClientId: this.state.conversationClientId,
            conversationClientSecret: this.state.conversationClientSecret,
            voiceClientId: this.state.voiceClientId,
            voiceClientSecret: this.state.voiceClientSecret,
            subTypeMapping: JSON.stringify(this.state.subTypeMapping)
        };

        console.log(job);
        console.log("JOB");

        var data = await this.props.apol
            .mutate({
                mutation: mutationMarkDeleteExportRule,
                refetchQueries: [{
                    query: queryGetConfigData,
                    variables: { auth: this.props.authorization },
                }],
                variables: {
                    auth: this.props.authorization,
                    rule: job,
                }
            });

        if (data.data.markDeleteExportRule == null) {
            toast.info('Job delete not successful', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            toast.info('Job moved to archive', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }



        this.setState({ jobDeletionActive: false });
        this.props.closeModal();
    }

    savePanel = () => {
        // Save Changes
        let exportUserIds = [];
        for (let x = 0; x < this.state.exportUser.length; x++) {
            exportUserIds.push(this.state.exportUser[x].key);
        };

        let defaultRegion = this.state.defaultRegion;
        let pgpEncryption = this.state.PGPEncryption;
        let pgpEncryptionKeyUpload = this.state.pgpEncryptionKeyUpload;

        if (this.state.exportType !== "AWS" && this.state.exportType !== "SurveilX"&& this.state.exportType !== "SFTP") {
            defaultRegion = "";
            pgpEncryption = false;
            pgpEncryptionKeyUpload = "";
        }

        let filterTypeKomma = "";
        for (let x = 0; x < this.state.filterType.length; x++) {
            if (x !== 0)
                filterTypeKomma += ",";
            filterTypeKomma += this.state.filterType[x];

        };

        const allowedTypes = ["Blobstorage", "Neo", "Hubstor", "SFTP", "AWS", "NeoTransfer"];
        let policyResultTypes = allowedTypes.includes(this.state.exportType)
            ? this.state.policyResultTypes
            : 0;


        let job =
        {
            id: this.state.id,
            name: this.state.name,
            userIds: exportUserIds,
            sourceTtl: this.state.sourceTtlEnabled ? parseInt(this.state.sourceTtl) : -1,
            storageConnectionString: this.state.storageConnectionString,
            storageContainerName: this.state.storageContainerName,
            storageRootDirectory: this.state.storageRootDirectory,
            conversationType: this.state.mediaType,
            exportType: this.state.exportType,
            audioCodec: this.state.audioCodec,
            policyResultType: policyResultTypes,
            callStartTime: this.state.callStartTime === '' ? null : this.state.callStartTime,
            callEndTime: this.state.callEndTime === '' ? null : this.state.callEndTime,
            enabled: this.state.enabled ? true : false,
            processingRegion: this.state.processingRegion,
            jobType: {
                intervalType: this.state.intervalType,
                jobStartTime: this.state.jobStartTime === '' ? null : this.state.jobStartTime,
                intervalMonth: parseInt(this.state.intervalMonth),
                intervalDay: parseInt(this.state.intervalDay),
                intervalHour: parseInt(this.state.intervalHour),
                intervalMinute: parseInt(this.state.intervalMinute)
            },
            defaultRegion: defaultRegion,
            pgpEncryption: pgpEncryption,
            pgpEncryptionKeyUpload: pgpEncryptionKeyUpload,
            sftpPrivateKeyUpload: this.state.sftpPrivateKeyUpload,
            auditEventTypes: this.state.auditEventTypes,
            mergeAudioToVideo: this.state.mergeAudioToVideo,
            metadataInTranscript: this.state.metadataInTranscript,
            transferId: this.state.transferId,
            encryptionKeyVaultUrl: this.state.encryptionKeyVaultUrl,
            customFieldKey: this.state.customFieldKey,
            customFieldValue: this.state.customFieldValue,
            isCustomFieldEqual: this.state.isCustomFieldEqual,
            conversationClientId: this.state.conversationClientId,
            conversationClientSecret: this.state.conversationClientSecret,
            voiceClientId: this.state.voiceClientId,
            voiceClientSecret: this.state.voiceClientSecret,
            subTypeMapping: JSON.stringify(this.state.subTypeMapping),
            filterType: filterTypeKomma,
            durationFrom: this.state.durationFrom,
            durationTo: this.state.durationTo,
            participantCountFrom: this.state.participantCountFrom,
            participantCountTo: this.state.participantCountTo,
            sftpPublicKey: this.state.sftpPublicKeyFileContent,
            sftpPrivateKey: this.state.sftpPrivateKeyFileContent,
            sftpPrivateKeyKeyVaultUrl: this.state.sftpPrivateKeyKeyVaultUrl,
            sftpPrivateKeyKeyVaultSecretName: this.state.sftpPrivateKeyKeyVaultSecretName,
            exportMetadata: this.state.exportMetadata,

        };
        if (this.props.data != null) {

            this.props.apol
                .mutate({
                    mutation: gql`
                    mutation ent (
                        $input: AuthInput, 
                        $exportJob: ExportRuleInputType) {
                        updateExportJob (
                            input: $input, 
                            exportJob: $exportJob
                        ) 
                        {
                            id
                        }
                    }
                `,
                    refetchQueries: [{
                        query: queryGetConfigData,
                        variables: { auth: this.props.authorization },
                    }],
                    variables: {
                        input: this.props.input,
                        exportJob: job
                    },
                })
                .then((result) => {

                    if (result.data.updateExportJob !== null) {
                        toast.info('Export Job changed', {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    } else {
                        toast.error('Export Job not changed', {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    }

                });
        }
        else {
            this.props.apol
                .mutate({
                    mutation: gql`
                    mutation ent (
                        $input: AuthInput, 
                        $exportJob: ExportRuleInputType) {
                        createExportJob (
                            input: $input, 
                            exportJob: $exportJob
                        ) 
                        {
                            id
                        }
                    }
                `,
                    refetchQueries: [{
                        query: queryGetConfigData,
                        variables: { auth: this.props.authorization },
                    }],
                    variables: {
                        input: this.props.input,
                        exportJob: job
                    },
                })
                .then((result) => {
                    if (result.data.updateExportJob !== null) {
                        toast.info('Export Job created', {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    } else {
                        toast.error('Export Job not created', {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    }


                });
        }
        this.props.closeModal();

    };


}
export default ExportConfig;